import React from 'react';
import PropTypes from 'prop-types';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import styles from './CheckIcon.less';
import classnames from 'classnames';

export const CheckIcon = ({ checked, className }) => {
  return (
    <div className="text-center">
      {checked ? (
        <CheckOutlined className={classnames(styles.check, className)} />
      ) : (
        <CloseOutlined className={classnames(styles.close, className)} />
      )}
    </div>
  );
};

CheckIcon.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.object,
};
